import { supabase } from '@/lib/supabase/client';

/**
 * Check if GA data exists in base tables vs materialized view
 */

export async function debugGAInBaseTable() {
  console.log('🔍 Checking GA data in base tables vs materialized view...');

  try {
    // Check if GA exists in the base cars table (not materialized view)
    const { data: baseCars, error: baseCarsError } = await supabase
      .from('cars')
      .select('*', { count: 'exact', head: true })
      .eq('seller_region', 'GA');

    console.log(`📊 Base cars table - GA records: ${baseCars?.length || 'Error'}`, baseCarsError);

    // Check safety_recalls table for GA data
    const { data: baseRecalls, error: baseRecallsError } = await supabase
      .from('safety_recalls')
      .select('*', { count: 'exact', head: true })
      .limit(1);

    console.log(
      `📊 Safety recalls table total: ${baseRecalls?.length || 'Error'}`,
      baseRecallsError
    );

    // Check if materialized view exists and when it was last refreshed
    const { data: mvInfo, error: mvError } = await supabase
      .rpc('pg_stat_user_tables')
      .select('*')
      .ilike('relname', '%cars_with_safety_recalls_mv%');

    console.log('🔄 Materialized view info:', mvInfo, mvError);

    // Check all states in materialized view
    const { data: allStates, error: statesError } = await supabase
      .from('cars_with_safety_recalls_mv')
      .select('seller_region', { count: 'exact' })
      .not('seller_region', 'is', null);

    if (statesError) {
      console.error('❌ Error getting states from MV:', statesError);
    } else {
      console.log(`📍 Total records in materialized view: ${allStates?.length || 0}`);

      // Get unique states
      const { data: uniqueStates } = await supabase
        .from('cars_with_safety_recalls_mv')
        .select('seller_region')
        .not('seller_region', 'is', null);

      if (uniqueStates) {
        const stateSet = new Set(uniqueStates.map(r => r.seller_region));
        console.log(`📍 States in materialized view: ${Array.from(stateSet).sort().join(', ')}`);
        console.log(`📍 GA in materialized view: ${stateSet.has('GA') ? 'YES' : 'NO'}`);
      }
    }

    return {
      baseCarsGA: baseCars?.length || 0,
      totalMVRecords: allStates?.length || 0
    };
  } catch (error) {
    console.error('❌ Debug failed:', error);
    return null;
  }
}

// Export to window for console access
if (typeof window !== 'undefined') {
  (window as any).debugGAInBaseTable = debugGAInBaseTable;
}

export default debugGAInBaseTable;
